import React, { Component } from 'react'
import styled from 'styled-components'
import { device, getNetPrice, getTax, priceFormatted } from '../../../utils/helpers'
import Modal from 'react-modal'
import EnquiryPopup from '../../Pages/Strutture/EnquiryPopup'

const Wrapper = styled.div`
  display: flex;
  font-size: 16px;
  font-family: 'BarlowSemiBold';
  color: #fff;
  text-transform: uppercase;
  height: 65px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`

const PriceLeft = styled.div`
  background-color: ${props => props.theme.color.bgMedium};
  display: flex;
  justify-content: space-around;
  flex-basis: 60%;

  @media ${device.tablet} {
    flex-basis: 70%;
  }
`

const PriceRight = styled.div`
  background-color: ${props => props.theme.color.bgYellow};
  flex-basis: 40%;
  padding-left: 12px;

  @media ${device.tablet} {
    flex-basis: 30%;
  }
`

const PriceItemWrapper = styled.div`
  padding: 0.5rem;

  @media ${device.tablet} {
    padding: 0.5rem;
  }
`

const PriceWrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${device.tablet} {
    width: 50%;
  }

  @media ${device.laptop} {
    width: 100%;
  }

  @media ${device.laptopM} {
    width: 55%;
  }

  @media ${device.laptopL} {
    width: 50%;
  }
`

const ButtonWrapper = styled.div`
  padding: 1.2rem 0;
  width: 100%;

  @media ${device.tablet} {
    ${''}
    width: 48%;
  }

  @media ${device.laptop} {
    padding-left: 0;
    width: 100%;
  }

  @media ${device.laptopM} {
    width: 43%;
  }

  ${'' /* @media (min-width: 1236px) {
    padding-left: 1rem;
  } */}

  @media ${device.laptopL} {
    ${''}
    width: 48%;
  }
`

const Button = styled.button`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  font-size: 16px;
  color: #fff;
  border: 5px solid #4d4d4d;
  color: #4d4d4d;
  background-color: white;
  padding: 18px 55px;
  text-transform: uppercase;
  transition: all 0.5s ease;
  cursor: pointer;
  width: 100%;

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  @media ${device.mobileMinM} {
    font-size: 18px;
  }

  @media ${device.tablet} {
    font-size: 21px;
    padding: 16px 25px;
  }

  @media ${device.laptopM} {
    font-size: 20px;
    padding: 18px 20px;
  }

  @media ${device.laptopL} {
    font-size: 21px;
    padding: 18px 25px;
  }
`

const PriceItem = ({ top, bottom }) =>
  <PriceItemWrapper>
    <div style={{ paddingBottom: '2px' }}>
      {top}
    </div>
    <div>
      {bottom}
    </div>
  </PriceItemWrapper>

class Price extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalOpen: false
    }
  }

  openModal () {
    this.setState({ modalOpen: true })
  }

  closeModal () {
    this.setState({ modalOpen: false })
  }

  render () {
    const { amount, quantity, duration, addon, product } = this.props
    const netPrice = getNetPrice(amount)
    const taxPrice = getTax(amount)
    return (
      <Wrapper>
        <PriceWrapper>
          <PriceLeft>
            <PriceItem top='Tot. Netto' bottom='IVA 22.00%' />
            <PriceItem top={priceFormatted(netPrice)} bottom={priceFormatted(taxPrice)} />
          </PriceLeft>
          <PriceRight>
            <PriceItem top='Totale' bottom={priceFormatted(amount)} />
          </PriceRight>
        </PriceWrapper>
        <ButtonWrapper>
          <Button onClick={this.openModal.bind(this)}>Salva Preventivo</Button>
        </ButtonWrapper>
        <Modal
          isOpen={this.state.modalOpen}
          className='Modal'
          overlayClassName='Overlay'
        >
          <EnquiryPopup quantity={quantity} duration={duration} addon={addon} product={product} closeModal={this.closeModal.bind(this)} />
        </Modal>
      </Wrapper>
    )
  }
}

export default Price



// WEBPACK FOOTER //
// ./src/components/UI/Misc/Price.js